import Vue from 'vue';
import VueBootstrap from 'bootstrap-vue';
import VueAxios from 'vue-axios';
import VueMoment from 'vue-moment';
import VueSocketIO from 'vue-socket.io';
import axios from 'axios';
import numFormat from 'vue-filter-number-format';

import App from './App.vue';
import store from './store';
import routes from './routes';
import token from './libs/boogr-token';

Vue.filter('numFormat', numFormat);

Vue.use(VueBootstrap);
Vue.use(VueMoment);
Vue.use(VueAxios, axios);
// Vue.use(new VueSocketIO({
//     debug: true,
//     connection: process.env.VUE_APP_BASE_API,
//     vuex: {
//         store,
//         actionPrefix: 'SOCKET_',
//         mutationPrefix: 'SOCKET_'
//     }
// }));
Vue.use(new VueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_BASE_SOCKET,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
    },
    // autoConnect: true,
    // transports: ['websocket', 'xhr-polling', 'jsonp-polling'],
    options: { path: '/socket.io' }
}));

// TODO :MULTIPLE SOCKET
// baca lagi di https://github.com/codeasashu/Vue-Socket.io/blob/8fa80e147ce7404db10fddfca491dddb40a3b3f3/src/Main.js
// let connectObj = {
//     notification: 'https://starter.ekossystem.com',
//     client: 'http://localhost:5020'
//   }  
  
// Vue.use(VueSocketIO, connectObj,store);

axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios.defaults.headers['Content-type'] = 'application/json';

global.Vue = Vue;

(async () => {
    token.validate();
    const router = await routes.instance();
    return new Vue({ 
        sockets: {
            connect: function (socket) {
                console.log('socket connected')
            },
            customEmit: function (data) {
                // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
            },
            saveOrder: function (data) {
                console.log('saveOrder :',data)
            },
        },
        router,
        store,
        render: h => h(App),
        created: function () {
            token.refresh(1000 * 60 * 30);
            window.router = router;
        }
    }).$mount('#app');
})();

window._store = store;
